<template>
  <div class="standings">
    <match-tabs :top1="1" :matchId="matchId" :sportType="match.sportType" v-if="!hasScreenshot"></match-tabs>
    <share-top :name="match.group || match.chineseName" :icon="filterImage(match.unionIcon || match.icon)" type="积分榜"
      v-else></share-top>
    <div v-if="ruleType === '淘汰赛'">
      <PromotionChart :rounds="rounds" />
    </div>
    <div v-else-if="ruleType !== '自定义'">
      <div v-for="item, i in list" :key="i">
        <div v-if="item.sportType == '足球'">
          <div class="tr">
            <div class="td colspan3">{{ item.name }}</div>
            <div>{{ $t('match.standings.text_1') }}</div>
            <div>{{ $t('match.standings.text_2') }}</div>
            <div>{{ $t('match.standings.text_3') }}</div>
            <div>{{ $t('match.standings.text_4') }}</div>
            <div class="colspan2">{{ $t('match.standings.text_5') }}</div>
            <div style="width: 35px;">{{ $t('match.standings.text_6') }}</div>
          </div>
          <div class="tr bg-color" v-for="teamScore, index in item.value" :key="teamScore.id">
            <div class="td colspan3 info">
              <span style="padding-left: 10px; width: 15px;">{{ index + 1 }}.</span>
              <img :src="filterImage(teamScore.badge, 30, 30)">
              <div class="name">{{ teamScore.teamAlias || teamScore.name }}</div>
            </div>
            <div>{{ teamScore.totalRound }}</div>
            <div>{{ teamScore.winRound }}</div>
            <div>{{ teamScore.tieRound }}</div>
            <div>{{ teamScore.loseRound }}</div>
            <div class="colspan2">{{ teamScore.goalCount }}/{{ teamScore.concededCount }}</div>
            <div style="width: 35px;"> {{ teamScore.totalScore }}</div>
          </div>
        </div>
        <div v-if="item.sportType == '篮球'">
          <div class="tr basketball">
            <div class="td colspan3 left" style="line-height: 60px;">{{ item.name }}</div>
            <div style="line-height: 60px;">{{ $t('match.standings.text_1') }}</div>
            <div style="line-height: 60px;">{{ $t('match.standings.text_2') }}</div>
            <div style="line-height: 60px;">{{ $t('match.standings.text_4') }}</div>
            <div style="line-height: 60px;">{{ $t('match.standings.text_7') }}</div>
            <div style="line-height: 60px;">{{ $t('match.standings.text_6') }}</div>
            <div class="flex-center" v-html="$t('match.standings.text_8')"></div>
            <div class="flex-center" v-html="$t('match.standings.text_9')"></div>
            <div class="flex-center" v-html="$t('match.standings.text_10')"></div>
          </div>
          <div class="tr bg-color basketball" v-for="teamScore in item.value" :key="teamScore.id">
            <div class="td colspan3 info">
              <span style="padding-left: 10px;" class="rankInGroup">{{ teamScore.rankInGroup }}</span>
              <div class="name"> {{ teamScore.teamAlias || teamScore.name }}</div>
            </div>
            <div>{{ teamScore.totalRound }}</div>
            <div>{{ teamScore.winRound }}</div>
            <div>{{ teamScore.loseRound }}</div>
            <div>{{ (teamScore.winRate && teamScore.winRate != 'N/A') ? (teamScore.winRate) : '-' }}</div>
            <div>{{ teamScore.totalScore }}</div>
            <div>{{ (teamScore.avgWinScorePerGame && teamScore.avgWinScorePerGame !=
              'N/A') ? teamScore.avgWinScorePerGame : '-' }}</div>
            <div>{{ (teamScore.avgConcededScorePerGame && teamScore.avgConcededScorePerGame !=
              'N/A') ? teamScore.avgConcededScorePerGame : '-' }}</div>
            <div>{{ (teamScore.avgNetWinScorePerGame && teamScore.avgNetWinScorePerGame !=
              'N/A') ? teamScore.avgNetWinScorePerGame : '-' }}</div>
          </div>
        </div>
        <div v-if="item.sportType == '橄榄球'">
          <div class="tr">
            <div class="td colspan3">{{ item.name }}</div>
            <div>赛</div>
            <div>胜/平/负</div>
            <div class="colspan2">胜率</div>
            <div style="width: 35px;">积分</div>
          </div>
          <div class="tr bg-color" v-for="teamScore, index in item.value" :key="teamScore.id">
            <div class="td colspan3 info">
              <span style="padding-left: 10px; width: 15px;">{{ index + 1 }}.</span>
              <img :src="filterImage(teamScore.badge, 30, 30)">
              <div class="name">{{ teamScore.teamAlias || teamScore.name }}</div>
            </div>
            <div>{{ teamScore.totalRound }}</div>
            <div style="width: 44px;">{{ teamScore.winRound }}/{{ teamScore.tieRound }}/{{ teamScore.loseRound }}</div>
            <div class="colspan2"> {{ teamScore.totalRound ? ((teamScore.winRound / teamScore.totalRound) *
              100).toFixed(0) + '%' : '' }}</div>
            <div style="width: 35px;"> {{ teamScore.totalScore }}</div>
          </div>
        </div>
        <div v-if="item.sportType == '棒球' || item.sportType == '排球'">
          <div class="tr">
            <div class="td colspan3 name1">{{ item.name }}</div>
            <div>赛</div>
            <div>胜</div>
            <div>负</div>
            <!--                <div class="colspan2">R/H/E</div>-->
            <div style="width: 35px;">积分</div>
            <div v-if="item.sportType == '排球'" style="width: 40px;">C值</div>
            <div v-if="item.sportType == '排球'" style="width: 40px;">Z值</div>
          </div>
          <div class="tr bg-color" v-for="teamScore, index in item.value" :key="teamScore.id">
            <div class="td colspan3 info">
              <span style="padding-left: 10px; width: 15px;">{{ index + 1 }}.</span>
              <img :src="filterImage(teamScore.badge, 30, 30)">
              <div class="name">{{ teamScore.teamAlias || teamScore.name }}</div>
            </div>
            <div>{{ teamScore.totalRound }}</div>
            <div>{{ teamScore.winRound }}</div>
            <div>{{ teamScore.loseRound }}</div>
            <!--                <div class="colspan2">{{ teamScore.goalCount }}/{{ teamScore.hitCount }}/{{ teamScore.errorCount }}</div>-->
            <div style="width: 35px;">{{ teamScore.totalScore }}</div>
            <div v-if="item.sportType == '排球'" style="width: 40px;">{{ parseFloat(teamScore.cValue).toFixed(2) }}</div>
            <div v-if="item.sportType == '排球'" style="width: 40px;">{{ parseFloat(teamScore.zValue).toFixed(2) }}</div>
          </div>
        </div>
        <div v-if="item.sportType == '羽毛球' || item.sportType == '乒乓球'">
          <div class="tr">
            <div class="td colspan3 name1">{{ item.name }}</div>
            <div style="width: 35px;" v-html="$t('match.standings.text_1')"></div>
            <div style="width: 35px;" v-html="$t('match.standings.text_2')"></div>
            <div style="width: 55px;" v-html="$t('match.standings.text_11')"></div>
            <div style="width: 55px;" v-html="$t('match.standings.text_12')"></div>
          </div>
          <div class="tr bg-color" v-for="teamScore, index in item.value" :key="teamScore.id">
            <div class="td colspan3 info">
              <span style="padding-left: 10px; width: 15px;font-size: 14px;font-weight: 700;">{{ index + 1 }}.</span>
              <img :src="filterImage(teamScore.badge, 30, 30)">
              <div class="name">{{ teamScore.teamAlias || teamScore.name }}</div>
            </div>
            <div style="width: 35px;">{{ teamScore.totalRound }}</div>
            <div style="width: 35px;">{{ teamScore.winRound - teamScore.winByShootoutRound }}</div>
            <div style="width: 55px;"> {{ teamScore.netWinGameStageCount }}</div>
            <div style="width: 55px;">{{ teamScore.netWinScoreCount }}</div>
          </div>
        </div>
        <div v-if="item.sportType == '冰球'">
          <div class="tr">
            <div class="td colspan3 name1" style="color: #4b93b3;">{{ item.name }}</div>
            <div>赛</div>
            <div>胜</div>
            <div>负</div>
            <div>任胜</div>
            <div>任负</div>
            <div>受罚</div>
            <div class="colspan2">进/失</div>
            <div style="width: 35px;">积分</div>
          </div>
          <div class="tr bg-color" v-for="teamScore, index in item.value" :key="teamScore.id">
            <div class="td colspan3 info">
              <span style="padding-left: 10px; width: 15px;">{{ index + 1 }}.</span>
              <img :src="filterImage(teamScore.badge, 30, 30)">
              <div class="name">{{ teamScore.teamAlias || teamScore.name }}</div>
            </div>
            <div>{{ teamScore.totalRound }}</div>
            <div>{{ teamScore.winRound - teamScore.winByShootoutRound }}</div>
            <div>{{ teamScore.loseRound - teamScore.loseByShootoutRound }}</div>
            <div>{{ teamScore.winByShootoutRound }}</div>
            <div>{{ teamScore.loseByShootoutRound }}</div>
            <div>{{ teamScore.penaltyTime }}</div>
            <div class="colspan2">{{ teamScore.goalCount }}/{{ teamScore.concededCount }}</div>
            <div style="width: 35px;">{{ teamScore.totalScore }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="custom">自定义阶段暂无数据展示</div>
    <div class="match-note">赛事数据统计由组委会提供</div>
    <div class="sponsor" v-if="sponsors.length > 0 && !hasScreenshot">
      <div class="item" v-for="item in sponsors" :key="item.id">
        <div class="top">赛事赞助商:</div>
        <div class="box">
          <img :src="filterImage(item.logoImg, 64, 64)">
          <div>
            {{ item.title }}
            <br>
            <span>{{ item.content }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" v-if="stages.length > 1 && !hasScreenshot">
      <div class="footer-box" ref="footer">
        <div v-for="item in stages" :key="item.id" class="item" :class="{ selected: item.id === currentRound }"
          @click="goRound(item)">{{ item.stageName }}</div>
      </div>
    </div>
    <share-footer :matchId="matchId" v-else-if="hasScreenshot"></share-footer>
  </div>
</template>

<script>
import matchTabs from './components/MatchTabs'
import PromotionChart from './components/PromotionChart2'
import shareTop from './components/ShareTop.vue'
import shareFooter from './components/ShareFooter.vue'
import { QNImageUtil } from '@/utils'
import { getBMTeamScores1, getBMMatchSponsorList, getBMStageGamesByBMMatchId, getBMMatchStageGameList } from '@/api/match'
export default {
  components: { matchTabs, PromotionChart, shareTop, shareFooter },
  data() {
    return {
      matchId: null,
      match: {},
      teamScores: [],
      list: [],
      sponsors: [],
      stages: [],
      currentRound: null,
      ruleType: '',
      rounds: [],
      hasScreenshot: false,
      obj: {}
    }
  },
  created() {
    this.matchId = this.$route.query.matchId
    this.hasScreenshot = this.$route.query.hasScreenshot || false
    this.currentRound = this.$route.query.stageId || null
  },
  mounted() {
    this.getBMStageGamesByBMMatchId()
  },
  methods: {
    getBMStageGamesByBMMatchId() {
      const obj = {
        matchId: this.matchId,
      }
      getBMStageGamesByBMMatchId(obj).then(res => {
        const data = res.data
        this.match = data.match
        const unionMatch = res.data.unionMatch
        document.title = this.match.chineseName.split('_')[1] + '-积分榜'
        const shareObj = {
          title: this.match.chineseName.split('_')[0] + this.getPromotion(unionMatch.beginDate, unionMatch.endDate),
          abstract: this.match.chineseName.split('_')[1] + '/积分榜',
          image: QNImageUtil.imageView(this.match.icon)
        }
        this.wxShare(shareObj)
        this.obj = data.match
        const stages = data.stages
        if (stages.length > 0) { // 多阶段
          this.stages = stages
          if (this.currentRound) { // 参赛携带阶段id
            this.ruleType = stages.find(item => item.id === this.currentRound)?.ruleType
          } else {
            this.currentRound = this.stages[0].id
            this.ruleType = this.stages[0].ruleType
          }
        } else {
          this.stages = [{ id: '', ruleType: '' }]
          this.ruleType = data.match.ruleType
        }

        if (['循环赛', '双循环'].includes(this.ruleType)) {
          this.getBMTeamScores()
        } else if (this.ruleType === '淘汰赛') {
          this.getBMMatchStageGameList()
        } else {
          this.getBMTeamScores()
        }

      })
    },
    getPromotion(createDate, endDate) {
      const startTime = new Date(createDate)
      const endTime = new Date(endDate)
      const currentTime = new Date()
      if (currentTime < startTime) {
        return '-敬请期待';
      } else if (currentTime >= startTime && currentTime <= endTime) {
        return '-激战正酣';
      } else {
        return '-完美闭幕';
      }
    },
    getBMTeamScores() {
      const params = {
        matchId: this.matchId,
        pageSize: 1000,
        stageId: this.currentRound
      }
      getBMTeamScores1(params).then(res => {
        const data = res.data
        this.match = data.match
        this.teamScores = data.teamScores
        var groups = []
        let groupName = ''
        const groupObject = {}
        for (var i = 0; i < this.teamScores.length; i++) {
          var score = this.teamScores[i]
          groupName = score.groupName
          if (groupObject[groupName]) {
            groupObject[groupName].push(score)
          } else {
            groupObject[groupName] = [score]
          }
        }

        if (data.groups && data.groups.length > 1) {
          // 如果是杯赛,将分好的组按接口返回的顺序排序
          var orderedGroupNames = data.groups.map(function (group) {
            return group.name
          })
          for (var j = 0; j < orderedGroupNames.length; j++) {
            groupName = orderedGroupNames[j]
            groups.push({ name: groupName, value: groupObject[groupName], sportType: this.match.sportType })
          }
        } else {
          // 如果是联赛,不需要分组
          groups.push({ name: groupName, value: groupObject[groupName], sportType: this.match.sportType })
        }
        this.list = groups
      })
    },
    getBMMatchStageGameList() {
      const params = {
        matchId: this.matchId,
        pageSize: 1000,
        stageId: this.currentRound
      }
      getBMMatchStageGameList(params).then(res => {
        const data = res.data
        this.rounds = data.rounds
        console.log(this.rounds);
      })
    },
    goRound(obj) {
      console.log(obj)
      this.currentRound = obj.id
      this.ruleType = obj.ruleType
      if (['循环赛', '双循环'].includes(this.ruleType)) {
        this.getBMTeamScores()
      } else if (this.ruleType === '淘汰赛') {
        this.getBMMatchStageGameList()
      } else {
        console.log(111);
      }
    },
    getBMMatchSponsorList() {
      getBMMatchSponsorList({ matchId: this.matchId }).then(res => {
        this.sponsors = res.data.sponsors
      })
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    }
  }
}
</script>

<style scoped lang="scss">
.standings {
  font-size: 12px;
  padding-bottom: 60px;

  .tr {
    background-color: #f2f2f2;
    min-height: 30px;
    line-height: 30px;
    display: flex;
    text-align: center;

    div {
      min-width: 28px;
    }

    .colspan3 {
      flex: 1;
      max-width: 225px;
    }

    .name1 {
      text-align: left;
      padding-left: 5px;
      font-weight: 700;
      font-style: italic;
    }

    .left {
      text-align: left;
      padding-left: 10px;
      font-weight: bold;
      font-style: italic;
    }

    .colspan2 {
      width: 43px;
    }

    .info {
      display: flex;
      align-items: center;

      img {
        width: 30px;
        height: 30px;
        border-radius: 5px;
        margin-left: 10px;
      }

      .name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-left: 15px;
      }

      .rankInGroup {
        font-size: 14px;
        font-weight: 600;
      }
    }
  }

  .basketball {
    div {
      min-width: 32px;
    }
  }

  .bg-color {
    background-color: #fff;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #f0f0f0;
  }

  .match-note {
    font-size: 13px;
    color: #b5b5b5;
    padding: 10px;
    text-align: center;
  }

  .sponsor {
    background-color: #fff;

    .item {
      padding: 0 20px;

      .top {
        font-size: 14px;
        color: #ababab;
      }

      .box {
        display: flex;
        padding: 10px 0;

        img {
          width: 64px;
          height: 64px;
          margin-right: 10px;
        }

        div {
          font-size: 14px;

          span {
            font-size: 12px;
            color: #ababab;
          }
        }
      }
    }
  }

  .custom {
    text-align: center;
    margin: 20px 0;
    font-size: 14px;
    color: #666;
  }
}

.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  padding-bottom: 20px;

  .footer-box {
    overflow-x: scroll;
    white-space: nowrap;
    display: flex;
    text-align: center;
    border-top: solid 1px lightgrey;

    .item {
      padding: 12px;
      font-size: 14px;
      box-sizing: border-box;
    }

    .selected {
      border-top: solid 3px #b40000;
      color: #B40000;
    }
  }
}
</style>
